module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Your audience deserves it.","body":"Your visitors come to your website with a goal. Whatever their goal is, we design your website in such a way that it\u0027s easy for your visitors to achieve those goals."},"nl":{"title":"Waar we het voor doen.","body":""}}')
  delete Component.options._Ctor
}
